module.exports = __webpack_public_path__ + "static/media/logo.86fef799.svg";